import React, {ComponentProps, FC, ReactNode} from 'react';
import styled from 'styled-components';

import {MacroTriggersContainer} from './macroTriggersContainer';

/*
 * Props.
 */

interface MacroTriggersChatTimelineProps extends ComponentProps<typeof MacroTriggersContainer> {}

/*
 * Style.
 */

const StyledMacroTriggersChatTimelineDiv = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
`;

/*
 * Component.
 */

export const MacroTriggersChatTimeline: FC<MacroTriggersChatTimelineProps> = ({message, panelId}) => (
  <MacroTriggersContainer
    message={message}
    panelId={panelId}
    // Render the padding only when there is a trigger button.
    renderWrapper={renderWrapper}
  />
);

function renderWrapper(children: ReactNode) {
  return <StyledMacroTriggersChatTimelineDiv>{children}</StyledMacroTriggersChatTimelineDiv>;
}
